export const visit = (vm, at) => {
at({ "en": { "priceComponents": { "pricePerMonth": "{{price}}/mo", "pricePerMonth_New": "{{price}} per month", "pricePerMonthPerSeat": "{{price}}/mo/seat", "pricePerMonthPerSeat_New": "{{price}} per month per seat", "subtexts": { "startsAt": "Starts at" } } } });
};